import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-4133ab06"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "row justify-content-start cantainer"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "canvas-cantainer"
}, [/*#__PURE__*/_createElementVNode("canvas", {
  id: "canvas",
  class: "canvas"
})], -1));

const _hoisted_3 = {
  class: "col-md-10 scroll-wrap",
  role: "main"
};
const _hoisted_4 = {
  class: "scrollbar-wrap"
};
import axios from "axios";
import HomeBlogCategory from "../../components/blog/HomeBlogCategory.vue";
import HomeBlogLeftSide from "../../components/blog/HomeBlogLeftSide.vue";
import HomeBlogNav from "../../components/blog/HomeBlogNav.vue";
import { computed, inject, ref, onMounted, watch } from "vue";
import { useRouter } from "vue-router";
import { initAeronautics } from '@/utils/aeronautics';
export default {
  __name: 'HomeBlog',

  setup(__props) {
    const menuJson = require("../blog/menu.json");

    const categoryInfoList = ref([]);
    const menu = ref([]);
    const router = useRouter();
    let filesPromises = Array(menuJson.categories.length);

    for (const i in menuJson.categories) {
      const item = menuJson.categories[i];
      item["order"] = i;
      menu.value.push(item);
      let filesPromise = axios.get(item.path + "/list.json").then(res => {
        let data = res.data;

        for (let key in item) {
          data[key] = item[key];
        }

        data["more"] = false;
        data["order"] = i;
        categoryInfoList.value.push(data);
      });
      filesPromises.push(filesPromise);
    }

    Promise.all(filesPromises).then(res => {
      menu.value.sort((a, b) => {
        return a.order - b.order;
      });
      categoryInfoList.value.sort((a, b) => {
        return a.order - b.order;
      });
    });
    onMounted(() => {// initAeronautics('canvas', 1920, 1080);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createVNode(HomeBlogLeftSide), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(HomeBlogNav, {
        menu: menu.value
      }, null, 8, ["menu"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryInfoList.value, categoryInfo => {
        return _openBlock(), _createBlock(HomeBlogCategory, {
          key: categoryInfo.aname,
          categoryInfo: categoryInfo
        }, null, 8, ["categoryInfo"]);
      }), 128))])])]);
    };
  }

};